import Filter from "../components/Filter";
import Grid from "../components/Grid";


export default function Homepage() {
  return (
    <main className="py-12 px-6 2xl:px-6 container">
      <div className="order-2 xl:-order-1">
        <Filter />
        <Grid/>
      </div>
    </main>
  )
};